export enum BooleanRenderMode {
    CHECKBOX = 'CHECKBOX',
    RADIO_BUTTONS = 'RADIO_BUTTONS'
}